import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=b25c31f6&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=b25c31f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25c31f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\shop-admin-vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b25c31f6')) {
      api.createRecord('b25c31f6', component.options)
    } else {
      api.reload('b25c31f6', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=b25c31f6&scoped=true&", function () {
      api.rerender('b25c31f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/aftersale/complaint/edit.vue"
export default component.exports